module.exports = __webpack_public_path__ + "img/playBtn.60bff451.png";